import { v4 as uuidv4 } from 'uuid';

export type StreamlitAppOptions = {
    code: string;
    guid?: string;
    streamlit_app_id?: number;
};

/**
 * Streamlit app names become K8s Service/Ingress names (`{guid}-{streamlit_app_id}`),
 * which must be DNS-1035 labels and therefore cannot start with a digit.
 */
export function makeGuidNotStartingWithDigit(): string {
    const startsWithDigit = /^\d/u;
    let id = uuidv4();
    console.log('id', id);

    while (startsWithDigit.test(id)) {
        id = uuidv4();
    }

    return id;
}

export function getStreamlitProductionUrl(guid: string, streamlitAppId: number): string {
    return `https://${guid}-${streamlitAppId}.${import.meta.env.VITE_STREAMLIT_DOMAIN}/`;
}

export function buildDefaultStreamlitXml(args: { caption?: string; code?: string; streamlit_app_id?: number } = {}): string {
    const { caption = '', code = '', streamlit_app_id } = args;
    const streamlitAppIdXml =
        streamlit_app_id !== undefined ? `<streamlit_app_id type="number">${streamlit_app_id}</streamlit_app_id>` : '';

    return `<zyTool name="StreamlitApp" caption="${caption}" activity_type="tinker" edited-last="${String(new Date())}">
<zyOptions type="dict"><code type="string">${code}</code>${streamlitAppIdXml}</zyOptions>
</zyTool>`;
}

/** Ensure zyTool XML carries the TipTap node id for the streamlit builder/save path. */
export function ensureStreamlitXmlId(xml: string, id: string | null | undefined): string {
    if (!xml || !id) {
        return xml;
    }

    if (/\bid="/u.test(xml)) {
        return xml.replace(/\bid="[^"]*"/u, `id="${id}"`);
    }

    return xml.replace(/<zyTool\b/u, `<zyTool id="${id}"`);
}
